import { Controller } from "@hotwired/stimulus"
import { ClipboardFeedback } from "../lib/clipboard_feedback.mjs"

// Clipboard API is an enhancement: the readonly source always remains selectable by hand.
export default class extends Controller {
  static targets = ["source", "button", "status"]
  static values = { copiedLabel: String, errorLabel: String }

  connect() {
    this.feedback = new ClipboardFeedback({
      button: this.buttonTarget,
      status: this.hasStatusTarget ? this.statusTarget : null,
      copiedLabel: this.copiedLabelValue,
      errorLabel: this.errorLabelValue,
      timers: window
    })
    if (navigator.clipboard?.writeText) this.buttonTarget.classList.remove("hidden")
  }

  disconnect() {
    this.feedback?.clear()
  }

  async copy() {
    await this.feedback.copy(
      this.sourceTarget.value,
      navigator.clipboard.writeText.bind(navigator.clipboard)
    )
  }
}
